import VKConnectReal from '@vkontakte/vkui-connect';
import VKConnectMock from '@vkontakte/vkui-connect-mock';
import * as VKActions from '../store/vk/actions';
import { APP_ID } from "./_globals";

const VKConnect = (process.env.NODE_ENV === 'production') ? VKConnectReal : VKConnectMock;
const API_VERSION       = '5.70';


export const initApp = () => async(dispatch) => {
    return new Promise((resolve, reject) => {
        let handler = async(e) => {
            let vkEvent = e.detail;
            let type = vkEvent.type;
            let data = vkEvent.data;

            switch (type) {

                case 'VKWebAppUpdateConfig':
                    document.body.setAttribute('scheme', data.scheme);
                    dispatch(VKActions.setInsets(data.insets));
                    break;

            }
        };
        VKConnect.subscribe(handler);
        VKConnect.send('VKWebAppInit', { 'no_toolbar': true });
    });
};


export const getAuthToken = (scope = '') => async (dispatch) => {
    return new Promise((resolve, reject) => {
        let handler = async(e) => {
            e = e.detail;
            let found = false;
            switch(e.type){

                case 'VKWebAppAccessTokenReceived':
                    found = true;
                    resolve(dispatch(VKActions.setAuthTokenSuccess(e.data.access_token)));
                    break;

                case 'VKWebAppAccessTokenFailed':
                    found = true;
                    resolve(dispatch(VKActions.setAuthTokenFail()));
                    break;

                default:
                    console.log(e);

            }
            if (found) VKConnect.unsubscribe(handler);
        };
        VKConnect.subscribe(handler);
        VKConnect.send("VKWebAppGetAuthToken", { "app_id": APP_ID, "scope": scope });
    });
};


export const getUserInfo = () => async (dispatch)  => {
    return new Promise((resolve, reject) => {
        let handler = async(e) => {
            e = e.detail;
            let found = false;

            switch(e.type){
                case 'VKWebAppGetUserInfoResult':
                    found = true;
                    resolve(dispatch(VKActions.setVkUser(e.data)));
                    return e.data;
                    break;

                case 'VKWebAppGetUserInfoFailed':
                    found = true;
                    reject(dispatch(VKActions.setVkUserFail()));
                    break;

                default:
                    console.log(e);
            }
            if (found) VKConnect.unsubscribe(handler);
        };
        VKConnect.subscribe(handler);
        VKConnect.send("VKWebAppGetUserInfo", {});
    });
};


export const getQRCode = (message) => async (dispatch)  => {
    return new Promise((resolve, reject) => {

        let handler = async(e) => {
            e = e.detail;
            let found = false;

            switch(e.type){
                case 'VKWebAppOpenQRResult':
                    found = true;
                    resolve(e.data);
                    break;

                case 'VKWebAppOpenQRFailed':
                    found = true;
                    resolve(e.data);
                    break;

                default:
                    console.log(e);
            }
            if (found) VKConnect.unsubscribe(handler);
        };
        VKConnect.subscribe(handler);
        VKConnect.send("VKWebAppOpenQR", {});
    });
};


export const apiRequest = (method, params = {}, accessToken = '', successCallback = undefined, failCallback = undefined) => async (dispatch) => {
    const requestId = (process.env.NODE_ENV === 'production') ? getNewRequestId() : '324nnefj';

    return new Promise((resolve, reject) => {

        let handler = async (e) => {
            e = e.detail;
            let found = false;

            if (e.data.request_id === requestId) {
                switch (e.type) {
                    case 'VKWebAppCallAPIMethodResult':
                        found = true;
                        if (successCallback !== undefined) successCallback(e.data.response);
                        resolve(e.data.response);
                        break;

                    case 'VKWebAppCallAPIMethodFailed':
                        found = true;
                        if (failCallback !== undefined) failCallback(e.data);
                        reject(e.data);
                        break;

                    default:
                        console.log(e);
                }
                if (found) VKConnect.unsubscribe(handler);
            }
        };

        VKConnect.subscribe(handler);

        params['access_token'] = accessToken;

        if (params['v'] === undefined) {
            params['v'] = API_VERSION;
        }

        VKConnect.send('VKWebAppCallAPIMethod', {
            'method': method,
            'params': params,
            'request_id': requestId,
        });
    });
};


function getNewRequestId() {
    return (Math.floor(Math.random() * Number.MAX_SAFE_INTEGER)).toString();
}


export function getLogs(state) {
   return JSON.stringify(state);
}


// WEBPACK FOOTER //
// ./src/js/services/vk.js